import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { WhiteBlock } from 'app/blocks/blocks';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import * as Utils from 'app/blocks/common/utils';
import ErrorLabel from 'app/blocks/ErrorLabel/ErrorLabel';
import { SubTitle } from 'app/blocks/titles/titles';
import PanelStatus from './PanelStatus';

import './Panel.scss';

class Panel extends PureComponent {
    static propTypes = {
        seleniumid: PropTypes.string,
        status: PropTypes.string,
        closed: PropTypes.bool.isRequired,
        header: PropTypes.node,
        headerContent: PropTypes.node,
        descr: PropTypes.node,
        warnMessage: PropTypes.node,
        children: PropTypes.node,
        togglePanel: PropTypes.func,
        toggleEventStart: PropTypes.func,
        toggleEventDone: PropTypes.func,
    };

    static defaultProps = {
        seleniumid: '',
        status: '',
        header: null,
        headerContent: null,
        descr: null,
        warnMessage: null,
        children: null,
        togglePanel: () => {},
        toggleEventStart: () => {},
        toggleEventDone: () => {},
    };

    panel = React.createRef();

    handleClick = () => {
        const { status, closed, toggleEventStart, togglePanel, toggleEventDone } = this.props;

        if (status === 'disabled') {
            return;
        }

        toggleEventStart(!closed);
        togglePanel();
        toggleEventDone(!closed);

        if (closed) {
            Utils.scrollToElement(this.panel.current, 400, -50);
        }
    };

    render() {
        const { seleniumid, header, headerContent, descr, status, closed, warnMessage, children } = this.props;

        return (
            <WhiteBlock
                ref={this.panel}
                className={cn('Panel p_none', {
                    Panel_disabled: status === 'disabled',
                    Panel_opened: !closed,
                    Panel_closed: closed,
                })}
                data-seleniumid={`${seleniumid}-panelParent`}
            >
                <div
                    className="p-2x p-btm_none mb-2x base_pointer"
                    data-seleniumid={`${seleniumid}-toggle`}
                    onClick={this.handleClick}
                    role="presentation"
                >
                    {header && <SubTitle>{header}</SubTitle>}
                    {headerContent && <div>{headerContent}</div>}
                    <div className="Panel__arrow">
                        <SvgIcon.chevron
                            className="Panel__arrow-icon"
                            iconDescr="check mark symbol"
                            iconTitle="Stick arrow icon"
                        />
                    </div>
                    {(descr || status) && (
                        <div className="row m-top_mini">
                            <div className="col-md-3 order-md-2 m-btm_micro txtcolor">
                                <PanelStatus seleniumid={seleniumid} status={status} />
                            </div>
                            <div className="col-md-9 order-md-1 txtcolor">{descr}</div>
                        </div>
                    )}
                </div>
                <div className="Panel__content">
                    <div className="p-l_mini p-r_mini">
                        <ErrorLabel className={cn({ hidden: !warnMessage })} text={warnMessage} />
                    </div>

                    <div className="p-2x p-top_none">{children}</div>
                </div>
            </WhiteBlock>
        );
    }
}

export default Panel;
